import React from 'react';
import Layout from '../components/Layout';
import Profile from '../components/profile';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../recoil/atoms/userAtom';

const ProfilePage = () => {
    const navigate = useNavigate();
    const user = useRecoilValue(userAtom);

    if (localStorage.getItem('user-id-for-admin-panel')) {
        navigate('/main');
    }

    return (
        <Layout link={user.isLeader ? '/admin' : '/'}>
            <Profile />
        </Layout>
    );
};

export default ProfilePage;
